import { useEffect, useState } from "react";
import Select from "react-select";
import {
  mostraAlertaError,
  mostraAlertaOk,
  mostraAlertaWarning
} from "../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../componentes/axios/Axios";
import GestionUbicacion from "../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../componentes/googlemap/VerUbicacion";
import ModalWizardBootstrap from "../../componentes/modal/ModalWizardBootstrap";
import { ClientesGuardar, ImagenCliente } from "../../configuracion/apiUrls";
import { DireccionConfig } from "../../configuracion/Empresa";
import {
  regexContrasena,
  regexEmail,
  regexIdentidad,
  regexNombre,
  regexNombreVacio,
  regexRTN,
  regexTelefono
} from "../../configuracion/validaciones";
import IniciarRegistroGoogle from "../../componentes/googlemap/RegistroGoogle";

const ModalRegistroCliente = ({ datos }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    direccion: DireccionConfig.direccion,
    longitud: DireccionConfig.longitud,
    latitud: DireccionConfig.latitud,
  });
  const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [formularioClientes, setFormularioClientes] = useState({
    id: datos ? datos.id : null,
    nombre: datos ? datos.nombre : "",
    contrasena: datos ? datos.nombre : "",
    correo: datos ? datos.correo : "",
    rtn: datos ? datos.rtn : "",
    identidad: datos ? datos.identidad : "",
    primerNombre: datos ? datos.primerNombre : "",
    segundoNombre: datos ? datos.segundoNombre : "",
    primerApellido: datos ? datos.primerApellido : "",
    segundoApellido: datos ? datos.segundoApellido : "",
    telefonos: datos ? datos.EmpleadoTelefonos : [{ telefono: "" }],
    direcciones: datos
      ? datos.EmpleadoDireccions
      : [{ direccion: "", longitud: null, latitud: null }],
    genero: null,
    activo: true,
    imagen: datos ? datos.imagen : "clientes.jpeg",
    tipoUsuario: "Cliente",
  });
  const generos = [
    {
      value: 1,
      label: "Masculino",
      otro: "M",
    },
    {
      value: 2,
      label: "Femenino",
      otro: "F",
    },
  ];
  const [generoId, setGeneroId] = useState(null);
  const [urlImagen, setUrlImagen] = useState(ImagenCliente + "empleados.jpeg");
  const [errorRtn, setErrorRtn] = useState(false);
  const [errorIdentidad, setErrorIdentidad] = useState(false);
  const [ErrornombreUsuario, setErrorNombreUsuario] = useState(false);
  const [ErrorContrasena, setErrorContrasena] = useState(false);
  const [ErrorConfirmarContrasena, setErrorConfirmarContrasena] =
    useState(false);
  const [errorPrimerNombre, setErrorPrimerNombre] = useState(false);
  const [errorSegundoNombre, setErrorSegundoNombre] = useState(false);
  const [errorPrimerApellido, setErrorPrimerApellido] = useState(false);
  const [errorSegundoApellido, setErrorSegundoApellido] = useState(false);
  const [errorCorreo, setErrorCorreo] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [errorTelefonos, setErrorTelefonos] = useState([]);

  useEffect(() => {
    if (seleccionarDireccion) {
      setIsModalOpen(false);
      //agregarDireccion();
      //console.log(formularioClientes.direcciones.length);
      setFormularioClientes((prevState) => ({
        ...prevState,
        direcciones: [...prevState.direcciones, nuevaDireccion],
      }));
      setSeleccionarDireccion(false);
      //setNuevaDireccion({ direccion: "Dirección: H5V4+2Q2, Siguatepeque, Siguatepeque, Departamento de Comayagua, Honduras", longitud: -87.84306461526864, latitud: 14.592255371946488 });
    }
  }, [seleccionarDireccion]);

  useEffect(() => {
    setErrorContrasena(!regexContrasena.test(formularioClientes.contrasena));
    setErrorConfirmarContrasena(
      formularioClientes.contrasena !== passwordConfirm
    );
    setErrorNombreUsuario(!regexNombre.test(formularioClientes.nombre));
    setErrorCorreo(!regexEmail.test(formularioClientes.correo));
    setErrorPrimerNombre(formularioClientes.primerNombre.length < 3);
    setErrorPrimerApellido(formularioClientes.primerApellido.length < 3);

    if (formularioClientes.segundoNombre) {
      setErrorSegundoNombre(
        !regexNombreVacio.test(formularioClientes.segundoNombre)
      );
    }

    if (formularioClientes.segundoApellido) {
      setErrorSegundoApellido(
        !regexNombreVacio.test(formularioClientes.segundoApellido)
      );
    }

    if (formularioClientes.rtn) {
      setErrorRtn(!regexRTN.test(formularioClientes.rtn));
    } else {
      setErrorRtn(false);
    }

    if (formularioClientes.identidad) {
      setErrorIdentidad(!regexIdentidad.test(formularioClientes.identidad));
    } else {
      setErrorIdentidad(false);
    }
    const nuevosErrores = formularioClientes.telefonos.map((numero) => {
      if (numero.telefono.trim() === '') {
        return false;
      }
      return !regexTelefono.test(numero.telefono);
    });
    setErrorTelefonos(nuevosErrores);
  }, [formularioClientes, passwordConfirm]);

  useEffect(() => {
    let genero = "Masculino"; // Valor por defecto
    if (generoId === 2) genero = "Femenino";
    setFormularioClientes((prev) => ({
      ...prev,
      genero,
    }));
  }, [generoId]);
  

  useEffect(() => {
    if (modalIsOpen) {
      const generoSeleccionado = generos.find(
        (g) => g.label === datos?.genero
      );
      setGeneroId(generoSeleccionado ? generoSeleccionado.value : 1);
      setFormularioClientes({
        id: datos ? datos.id : null,
        nombre: datos ? datos.nombre : "",
        contrasena: datos ? datos.contrasena : "",
        correo: datos ? datos.correo : "",
        rtn: datos ? datos.rtn : "",
        identidad: datos ? datos.identidad : "",
        primerNombre: datos ? datos.primerNombre : "",
        segundoNombre: datos ? datos.segundoNombre : "",
        primerApellido: datos ? datos.primerApellido : "",
        segundoApellido: datos ? datos.segundoApellido : "",
        telefonos: datos ? datos.EmpleadoTelefonos : [{ telefono: "" }],
        direcciones: datos
          ? datos.EmpleadoDireccions
          : [{ direccion: "", longitud: null, latitud: null }],
        genero: datos ? datos.genero : "Masculino",
        activo: true,
        imagen: datos ? datos.imagen : "clientes.jpeg",
        tipoUsuario: "Cliente",
      });
    }
  }, [modalIsOpen]);
  

  const manejadorClientes = (event) => {
    setFormularioClientes({
      ...formularioClientes,
      [event.target.name]: event.target.value,
    });
  };

  const manejarCambioNumeros = (index, value) => {
    const nuevosNumeros = [...formularioClientes.telefonos];
    nuevosNumeros[index] = { telefono: value };

    setFormularioClientes({
      ...formularioClientes,
      telefonos: nuevosNumeros,
    });
  };

  const agregarNumero = () => {
    setFormularioClientes((prevState) => ({
      ...prevState,
      telefonos: [...prevState.telefonos, { telefono: "" }],
    }));
  };
  const eliminarNumero = (index) => {
    setFormularioClientes((prevState) => {
      const nuevosNumeros = [...prevState.telefonos];
      nuevosNumeros.splice(index, 1);
      return { ...prevState, telefonos: nuevosNumeros };
    });
  };

  const eliminarDireccion = (index) => {
    setFormularioClientes((prevState) => {
      const nuevasDirecciones = [...prevState.direcciones];
      nuevasDirecciones.splice(index, 1);
      return { ...prevState, direcciones: nuevasDirecciones };
    });
  };

  const limpiarDatos = () => {
    setFormularioClientes({
      id: null,
      correo: "",
      rtn: "",
      identidad: "",
      primerNombre: "",
      segundoNombre: "",
      primerApellido: "",
      segundoApellido: "",
      telefonos: [{ telefono: "" }],
      direcciones: [{ direccion: "", longitud: null, latitud: null }],
      genero: null,
      activo: true,
      contrasena: "",
      nombre: "",
      tipoUsuario: "Cliente",
    });
    setErrorRtn(false);
    setErrorIdentidad(false);
    setErrorPrimerNombre(false);
    setErrorSegundoNombre(false);
    setErrorPrimerApellido(false);
    setErrorSegundoApellido(false);
    setErrorCorreo(false);
    setErrorNombreUsuario(false);
    setErrorContrasena(false);
    setErrorConfirmarContrasena(false);
    setPasswordConfirm("");
  };
  const quitarCamposVacios = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };
  const guardarCliente = () => {
    if (
      ErrornombreUsuario ||
      ErrorContrasena ||
      ErrorConfirmarContrasena ||
      errorPrimerNombre ||
      errorSegundoNombre ||
      errorPrimerApellido ||
      errorSegundoApellido ||
      errorIdentidad ||
      errorCorreo
    ) {
      mostraAlertaWarning("Existen errores en la introducción de campos");
    } else {
      try {
        console.log(formularioClientes);
        const direccionesVacia = formularioClientes.direcciones.filter(
          (f) => f.direccion !== "" || f.longitud !== null || f.latitud !== null
        );
        const telefonosVacia = formularioClientes.telefonos.filter(
          (f) => f.telefono !== "" || f.telefono !== null
        );
        const datos = {
          ...formularioClientes,
          direcciones: direccionesVacia,
          telefonos: telefonosVacia,
        };
        const nuevosDatos = quitarCamposVacios(datos);
        AxiosPrivado.post(ClientesGuardar, nuevosDatos)
          .then((respuesta) => {
            console.log(respuesta);
            mostraAlertaOk("Registro creado correctamente");
            console.log("Género seleccionado:", formularioClientes.genero);
            console.log("Identidad:", formularioClientes.identidad);
            limpiarDatos();
            setModalIsOpen(false); // Cierra el modal
          })
          .catch((er) => {
            console.log(er);
            let msjError = "";
            switch (er.response.status) {
              case 400:
                if (er.response.data && Array.isArray(er.response.data)) {
                  er.response.data.forEach((f) => {
                    msjError += f.msg + ". ";
                  });
                } else {
                  msjError = er.response.data.error;
                }
                break;
              case 500:
                msjError = er.response.data.error;
                break;
              default:
                msjError = "Ocurrió un error desconocido.";
                break;
            }
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        mostraAlertaError("Error en la pedición");
      }
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const handleSocialSuccess = () => {
    setModalIsOpen(false);
  };

  return (
    <ModalWizardBootstrap
      titulo="Registro"
      nombreBoton="Eres nuevo registrate"
      estiloBoton="link-class text-primary"
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
      iconos={[
        "fas fa-rocket",
        "fas fa-info-circle",
        "fas fa-user",
        "fas fa-address-book",
      ]}
      linkStyle={true}
      onFinish={guardarCliente}
      size="lg"
      pasos={[
        {
          etiqueta: "Método de Registro",
          contenido: (
            <div className="d-flex flex-column align-items-center justify-content-center py-4">
              <h4 className="text-center mb-4 text-secondary">
                Selecciona cómo deseas registrarte
              </h4>

              <div className="col-10 col-md-6 d-grid gap-3">
                {/* Botones de Redes Sociales */}
                <IniciarRegistroGoogle onRegistrationSuccess={handleSocialSuccess} />
              </div>

              <div className="col-10 col-md-8 my-4 d-flex align-items-center">
                <div className="flex-grow-1 border-top"></div>
                <span className="mx-3 text-muted fw-bold">O usa tu correo</span>
                <div className="flex-grow-1 border-top"></div>
              </div>

              <div className="text-center">
                <p className="text-muted mb-0">
                  Para crear una cuenta manual llenando el formulario,<br />
                  haz clic en el botón <strong>Siguiente</strong> abajo.
                </p>
              </div>
            </div>
          )
        },
        {
          etiqueta: "Datos Personales",
          contenido: (
            <>
              {/* Datos personales */}
              <div className="row">
                <div className="col-lg-3 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="primerNombre">Primer Nombre</label>
                    <input
                      type="text"
                      className={`form-control ${errorPrimerNombre ? "is-invalid" : ""
                        }`}
                      id="text"
                      placeholder="Primer Nombre"
                      name="primerNombre"
                      value={formularioClientes.primerNombre}
                      onChange={manejadorClientes}
                    />
                    {errorPrimerNombre && (
                      <div className="invalid-feedback">
                        El primer nombre debe tener al menos 3 caracteres.
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="segundoNombre">Segundo Nombre</label>
                    <input
                      type="text"
                      className={`form-control ${errorSegundoNombre ? "is-invalid" : ""
                        }`}
                      id="text"
                      placeholder="Segundo Nombre"
                      name="segundoNombre"
                      value={formularioClientes.segundoNombre}
                      onChange={manejadorClientes}
                    />
                    {errorSegundoNombre && (
                      <div className="invalid-feedback">
                        El segundo nombre debe tener al menos 3 caracteres.
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="primerApellido">Primer Apellido</label>
                    <input
                      type="text"
                      className={`form-control ${errorPrimerApellido ? "is-invalid" : ""
                        }`}
                      id="text"
                      placeholder="Primer Apellido"
                      name="primerApellido"
                      value={formularioClientes.primerApellido}
                      onChange={manejadorClientes}
                    />
                    {errorPrimerApellido && (
                      <div className="invalid-feedback">
                        El primer apellido debe tener al menos 3 caracteres.
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="form-group">
                    <label htmlFor="segundoApellido">Segundo Apellido</label>
                    <input
                      type="text"
                      className={`form-control ${errorSegundoApellido ? "is-invalid" : ""
                        }`}
                      id="text"
                      placeholder="Segundo Apellido"
                      name="segundoApellido"
                      value={formularioClientes.segundoApellido}
                      onChange={manejadorClientes}
                    />
                    {errorSegundoApellido && (
                      <div className="invalid-feedback">
                        El segundo apellido debe tener al menos 3 caracteres.
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Datos del unicos */}
              <div className="row">
                <div className="col-sm-8 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">RTN</label>
                    <input
                      type="text"
                      className={`form-control ${errorRtn ? "is-invalid" : ""}`}
                      id="text"
                      placeholder="Ingrese el rtn"
                      name="rtn"
                      value={formularioClientes.rtn}
                      onChange={manejadorClientes}
                    />
                    {errorRtn && (
                      <div className="invalid-feedback">
                        El RTN debe tener exactamente 14 dígitos.
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Identidad</label>
                    <input
                      type="text"
                      className={`form-control ${errorIdentidad ? "is-invalid" : ""}`}
                      id="text"
                      placeholder="Ingrese la identidad"
                      name="identidad"
                      value={formularioClientes.identidad}
                      onChange={manejadorClientes}
                    />
                    {errorIdentidad && (
                      <div className="invalid-feedback">
                        La identidad debe tener exactamente 13 dígitos.
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-sm-8 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Correo</label>
                    <input
                      type="text"
                      className={`form-control ${errorCorreo ? "is-invalid" : ""}`}
                      id="text"
                      placeholder="Ingrese el correo"
                      name="correo"
                      value={formularioClientes.correo}
                      onChange={manejadorClientes}
                    />
                    {errorCorreo && (
                      <div className="invalid-feedback">
                        Correo electrónico inválido
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          ),
        },
        {
          etiqueta: "Datos Usuarios",
          contenido: (
            <>
              {/* Datos del usuario */}
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="usuario">Usuario</label>
                    <input
                      type="text"
                      className={`form-control ${ErrornombreUsuario ? "is-invalid" : ""
                        }`}
                      placeholder="Ingrese nombre de usuario"
                      value={formularioClientes.nombre}
                      onChange={manejadorClientes}
                      name="nombre"
                      autocomplete="off"
                      id="usuario-cliente"
                    />
                    {ErrornombreUsuario && (
                      <div className="invalid-feedback">
                        El nombre de usuario debe tener al menos 3 caracteres.
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="contrasena">Contraseña</label>
                    <div className="input-group">
                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Contraseña"
                        className={`form-control ${ErrorContrasena ? "is-invalid" : ""
                          }`}
                        value={formularioClientes.contrasena}
                        onChange={manejadorClientes}
                        name="contrasena"
                        autocomplete="new-password"
                        id="clave-nueva-cliente"
                      />
                      <div className="input-group-append">
                        <div
                          className="input-group-text"
                          onClick={togglePasswordVisibility}
                          style={{ cursor: "pointer" }}
                        >
                          <span
                            className={showPassword ? "fas fa-eye-slash" : "fas fa-eye"}
                          ></span>
                        </div>
                      </div>
                      {ErrorContrasena && (
                        <div className="invalid-feedback">
                          Contraseña inválida (debe tener mayúscula, minúscula, número, símbolo, 6-12 caracteres)
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form-group">
                    <label htmlFor="confirmarContrasena">Confirmar Contraseña</label>
                    <div className="input-group">
                      <input
                        type={showPasswordConfirm ? "text" : "password"}
                        className={`form-control ${ErrorConfirmarContrasena ? "is-invalid" : ""
                          }`}
                        placeholder="Confirmar Contraseña"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        name="passwordConfirm"
                        autocomplete="new-password"
                        id="clave-confirmar-cliente"
                      />
                      <div className="input-group-append">
                        <div
                          className="input-group-text"
                          onClick={togglePasswordVisibilityConfirm}
                          style={{ cursor: "pointer" }}
                        >
                          <span
                            className={
                              showPasswordConfirm ? "fas fa-eye-slash" : "fas fa-eye"
                            }
                          ></span>
                        </div>
                      </div>
                      {ErrorConfirmarContrasena && (
                        <div className="invalid-feedback">
                          Las contraseñas no coinciden.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ),
        },
        {
          etiqueta: "Telefonos y Direcciones",
          contenido: (
            <>
              {/*Numeros de telefonos */}
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <label>Teléfonos</label>
                  <div className="row">
                    <div className="col-sm-9">
                      <div className="form-group">
                        {formularioClientes.telefonos.map((numero, index) => (
                          <div key={index} className="input-group mb-3">
                            <input
                              type="text"
                              className={`form-control ${errorTelefonos[index] ? "is-invalid" : ""}`}
                              placeholder="Ej: 98908767"
                              name="telefono"
                              value={numero.telefono}
                              onChange={(event) =>
                                manejarCambioNumeros(index, event.target.value)
                              }
                            />
                            {formularioClientes.telefonos.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger mx-2"
                                onClick={() => eliminarNumero(index)}
                                width="20px"
                              >
                                <i className="fa fa-minus" aria-hidden="true"></i>
                              </button>
                            )}
                            {errorTelefonos[index] && (
                              <div className="invalid-feedback">
                                Número inválido. Debe tener entre 8 y 12 dígitos.
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <button
                        type="button"
                        className="btn btn-block btn-primary"
                        onClick={agregarNumero}
                      >
                        <i className="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/*Direcciones */}
              <div className="row">
                <div className="col-12">
                  <label>Direcciones</label>
                  <div className="pb-3">
                    <GestionUbicacion
                      direccion={nuevaDireccion}
                      setDireccion={setNuevaDireccion}
                      isModalOpen={isModalOpen}
                      setIsModalOpen={setIsModalOpen}
                      setSeleccionarDireccion={setSeleccionarDireccion}
                      textoBoton={"Agregar Ubicación"}
                      verdireccion={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    {formularioClientes.direcciones
                      .filter(f => f.direccion && f.latitud && f.longitud)
                      .map((f, index) => (
                        <div key={index} className="row">
                          <div className="col-9">
                            <p className="text-muted">{f.direccion}</p>
                          </div>
                          <div className="col-3">
                            <VerUbicacion direccion={f} />
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => eliminarDireccion(index)}
                            >
                              <i className="fa fa-minus" aria-hidden="true"></i>
                            </button>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Genero</label>
                    <Select
                      value={
                        generoId && generos.find((opcion) => opcion.value === generoId)
                      }
                      onChange={(event) => {
                        setGeneroId(event.value);
                      }}
                      options={generos}
                      isSearchable={true}
                    ></Select>
                  </div>
                </div>
              </div>
            </>
          ),
        },
      ]}
    >
    </ModalWizardBootstrap>
  );
};
export default ModalRegistroCliente;
